import React, { useEffect, useState } from 'react';
import { RegisterMFA } from '@milkmoovement/common_cognito_package';
import { useHistory } from 'react-router-dom';
import { onCognitoLogin } from '../../../auth/store/actions';
import { useDispatch } from 'react-redux';
import { getRegion } from '../../../../utils';
import { fetchRegionFromBackend } from '../../../../utils/regionConfig';

const RegisterMFAPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [region, setRegion] = useState(null);
    const [isLoadingRegion, setIsLoadingRegion] = useState(true);

    // Fetch region from backend on component mount
    useEffect(() => {
        const loadRegion = async () => {
            try {
                const fetchedRegion = await fetchRegionFromBackend();
                setRegion(fetchedRegion);
            } catch (error) {
                setRegion(getRegion(window.location.hostname));
            } finally {
                setIsLoadingRegion(false);
            }
        };
        loadRegion();
    }, []);

    const handleNavigateBack = () => history.push({ pathname: '/login' });
    const handleSucessfulLogin = async () => {
        dispatch(await onCognitoLogin());
    };

    // Show loading state while fetching region
    if (isLoadingRegion || !region) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <RegisterMFA
            onSucessfulLogin={handleSucessfulLogin}
            onNavigateBack={handleNavigateBack}
            metadata={{
                coreSystem: region,
            }}
        />
    );
};

export default RegisterMFAPage;
